import { useRef, useState } from 'react';
import { apiClient } from './api/client.js';

export function CreateBarcode({ label = 'Primary barcode', required = false, onValueChange }: { readonly label?: string; readonly required?: boolean; readonly onValueChange?: () => void }) {
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const revision = useRef(0);
  const pending = useRef(false);
  const generate = async () => {
    if (pending.current || value) return;
    pending.current = true; setBusy(true); setError('');
    const started = revision.current;
    try {
      const result = await apiClient.generateBarcode();
      // Typing (even typing then clearing) takes precedence over an in-flight result.
      if (revision.current === started) { setValue(result.barcode); onValueChange?.(); }
    } catch (reason) { setError(reason instanceof Error ? reason.message : 'Barcode generation failed. Try again.'); }
    finally { pending.current = false; setBusy(false); }
  };
  return <div className="create-barcode"><label>{label}<input name="barcode" maxLength={255} required={required} value={value}
    onChange={event => { revision.current++; setValue(event.target.value); }} /></label>
    <button type="button" disabled={busy || Boolean(value)} onClick={() => { void generate(); }}>{busy ? 'Creating barcode…' : 'Create Barcode'}</button>
    <small>Internal barcode only. Clear the field to generate; review before saving.</small>
    {error && <p role="alert">{error}</p>}</div>;
}
